import MonthlyTrainingPlan from "../../monthly-training-plan";
import MTPCreate from "../../monthly-training-plan/pages/MTP-create";
import MTPDetail from "../../monthly-training-plan/pages/MTP-detail";
import MTPEdit from "../../monthly-training-plan/pages/MTP-edit";

export const monthlyTrainingPlanRoutes = {
  monthlyTrainingPlanPage: {
    isAdmin: false,
    title: "5. Kế hoạch đào tạo tháng",
    path: "/procedure/monthly-training-plan",
    parentId: "procedure",
    component: MonthlyTrainingPlan,
  },
  createMonthlyTrainingPlanPage: {
    isAdmin: false,
    path: "/procedure/monthly-training-plan/create",
    parentId: "procedure",
    component: MTPCreate,
  },
  detailMonthlyTrainingPlanPage: {
    isAdmin: false,
    path: "/procedure/monthly-training-plan/:id",
    parentId: "procedure",
    component: MTPDetail,
  },
  editMonthlyTrainingPlanPage: {
    isAdmin: false,
    path: "/procedure/monthly-training-plan/:id/edit",
    parentId: "procedure",
    component: MTPEdit,
  },
};
